import { FC } from 'react'
import styled from 'styled-components'

interface ButtonTooltipProps {
  labelText: string
  className?: string
}

const ButtonTooltip: FC<ButtonTooltipProps> = ({ labelText, className }) => {
  return <StyledWrapper className={className}>{labelText}</StyledWrapper>
}

export default ButtonTooltip

const StyledWrapper = styled.div`
  position: absolute;
  height: 30px;
  top: 25px;
  left: -15px;
  display: flex;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #ff0066;
  color: #ff0066;
  background-color: #fff;
  border-radius: 5px;
  cursor: pointer;
  ::after {
    content: '';
    position: absolute;
    bottom: -12.5px;
    left: 10%;
    border: 7px solid transparent;
    border-top: 7px solid #fff;
    transform: translateX(-50%);
    z-index: 1;
  }
  ::before {
    content: '';
    position: absolute;
    bottom: -14px;
    left: 10%;
    border: 7px solid transparent;
    border-top: 7px solid #ff0066;
    transform: translateX(-50%);
    z-index: 0;
  }
`
